export default class FilterOption {
  static FREE_CANCELLATION = 'free-cancellation'
  static POINTS = 'points'
  static BREAKFAST = 'breakfast'
  static ACCESSIBLE_ROOMS = 'accessible-rooms'
  static PACKAGES = 'packages'
  static MULTIROOM_ID = 'multiroom-id'

  static freeCancellation({ order, selected }) {
    return new FreeCancellationFilterOption({ order, selected })
  }

  static points({ order, selected }) {
    return new PointsFilterOption({ order, selected })
  }

  static breakfast({ order, selected }) {
    return new BreakfastFilterOption({ order, selected })
  }

  static accessibleRooms({ order, selected }) {
    return new AccessibleRoomsFilterOption({ order, selected })
  }

  static packages({ order, selected }) {
    return new PackagesFilterOption({ order, selected })
  }

  static occupancyIds({ roomId, mealPlan, rateType, order, selected }) {
    return new OccupancyIdsFilterOption({ roomId, mealPlan, rateType, order, selected })
  }

  constructor({ code, label, order, selected, matches, roomIds }) {
    this.code = code
    this.label = label
    this.order = order
    this.selected = selected || false
    this.matches = matches || 0
    this.roomIds = roomIds || []
  }

  updateCounter = matches => this.copy({ matches })
  select = () => this.copy({ selected: true })
  unselect = () => this.copy({ selected: false })
  match(stay) { }
  copy = partial => { }
}

export class FreeCancellationFilterOption extends FilterOption {
  constructor({ order, selected, matches }) {
    super({
      code: FilterOption.FREE_CANCELLATION,
      label: 'rdFilterFreeCancellation',
      order,
      selected,
      matches
    })
  }

  match = stay => stay.isFreeCancellation()
  copy = partial => new FreeCancellationFilterOption({ ...this, ...partial })
}

export class PointsFilterOption extends FilterOption {
  constructor({ order, selected, matches }) {
    super({ code: FilterOption.POINTS, label: 'rdFilterPoints', order, selected, matches })
  }

  match = stay => stay.hasPoints()
  copy = partial => new PointsFilterOption({ ...this, ...partial })
}

export class BreakfastFilterOption extends FilterOption {
  constructor({ order, selected, matches }) {
    super({
      code: FilterOption.BREAKFAST,
      label: 'rdFilterBreakfastIncluded',
      order,
      selected,
      matches
    })
  }

  match = stay => stay.hasBreakfastIncluded()
  copy = partial => new BreakfastFilterOption({ ...this, ...partial })
}

export class AccessibleRoomsFilterOption extends FilterOption {
  constructor({ order, selected, matches }) {
    super({
      code: FilterOption.ACCESSIBLE_ROOMS,
      label: 'rdFilterAccessibleRooms',
      order,
      selected,
      matches
    })
  }

  match = stay => {
    return stay.isAccessible()
  }

  copy = partial => new AccessibleRoomsFilterOption({ ...this, ...partial })
}

export class PackagesFilterOption extends FilterOption {
  constructor({ order, selected, matches }) {
    super({ code: FilterOption.PACKAGES, label: 'rdFilterPackages', order, selected, matches })
  }

  match = stay => stay.isPackage()
  copy = partial => new PackagesFilterOption({ ...this, ...partial })
}

export class OccupancyIdsFilterOption extends FilterOption {
  constructor({ roomId, mealPlan, rateType, order, selected, matches }) {
    super({
      code: FilterOption.MULTIROOM_ID,
      label: 'multiroom',
      order,
      selected,
      matches,
      mealPlan,
      rateType
    })
    this.roomId = roomId
    this.mealPlan = mealPlan
    this.rateType = rateType
  }

  match = stay => {
    if (this.roomId === '1') {
      return stay.occupancyIds.includes(this.roomId)
    } else {
      return (
        stay.occupancyIds.includes(this.roomId) &&
        stay.mealPlan === this.mealPlan &&
        stay.code === this.rateType
      )
    }
  }

  copy = partial => new OccupancyIdsFilterOption({ ...this, ...partial })
}
